export const paymentForwarderKeys = {
  bankDetails: () => ['bank-details'] as const,
  paymentCards: (bankDetailsIds?: string[]) => ['payment-cards', bankDetailsIds] as const,
  paymentCard: (bankDetailsId?: string | null) => ['payment-card', bankDetailsId] as const,
  beneficiaryInfo: () => ['beneficiary-info'] as const,
  actFile: (actId: number) => ['act-file', actId] as const,
  signStatus: (actId: number) => ['sign-status', actId] as const,
  unsignedDocuments: () => ['unsigned-documents'] as const,
  unsignedReceipts: () => ['unsigned-receipts'] as const,
};
